export default class UrlBuilder {
	private url: URL;

	constructor(url: string | URL) {
		this.url = typeof url === "string" ? new URL(url) : url;
	}

	setParam(key: string, value: string): this {
		this.url.searchParams.set(key, value);
		return this;
	}

	toString(): string {
		return this.url.toString();
	}
}
